module.exports = __webpack_public_path__ + "img/gb-eng.7ec8c20a.svg";